import { render, staticRenderFns } from "./work-packages-unit.vue?vue&type=template&id=3f7f929f&scoped=true"
import script from "./work-packages-unit.vue?vue&type=script&lang=js"
export * from "./work-packages-unit.vue?vue&type=script&lang=js"
import style0 from "./work-packages-unit.vue?vue&type=style&index=0&id=3f7f929f&prod&lang=scss&scoped=true"
import style1 from "./work-packages-unit.vue?vue&type=style&index=1&id=3f7f929f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f929f",
  null
  
)

export default component.exports